import gql from 'graphql-tag';

// PKによる取得
export const GET_CELL_STATUS = gql`
  query(
    $cell_id: [String]
  ) {
    GetCellStatus(
        cell_id: $cell_id
    ) {
      CellStatusList{
        cell_id
        reserve_status
        player_left
        link_player_left
      }
    }
  }
`;
